import { render, staticRenderFns } from "./poster-review.vue?vue&type=template&id=4f840286&"
import script from "./poster-review.vue?vue&type=script&lang=js&"
export * from "./poster-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports